import React from 'react'

function AdjFloorOut() {
  return (
    <embed src="\pdfs\E1.3.3_BA-V-DN150_Adjustable_floor_outlet_05.2015_kr.pdf" width="100%" height="2100px" />
  )
}

export default AdjFloorOut